import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  hostedVideoActions,
  hostedVideoSelectors,
  PopoverType
} from '../../../../../../store/modules/hostedVideo';

import { PopoverTypeIndexes } from '.';
import { getDefaultTextValue } from './helpers';

const popoverTypeIndexMap: { [key in PopoverTypeIndexes]: PopoverType } = {
  0: 'thumbnail',
  1: 'highlight',
  2: 'text'
};

type UseUpdatePopoverProps = {
  playButtonStatus: boolean;
  activePopoverType: PopoverTypeIndexes;
};

export const useUpdatePopover = ({
  playButtonStatus,
  activePopoverType
}: UseUpdatePopoverProps) => {
  const dispatch = useDispatch();
  const popover = useSelector(hostedVideoSelectors.selectPopoverEmbed);
  const playerColor =
    useSelector(hostedVideoSelectors.selectPlayerColor) || DEFAULT_WAVE_COLOR;

  const updatePopover = useCallback(
    () =>
      dispatch(
        hostedVideoActions.updatePopoverEmbed({
          text: getDefaultTextValue(activePopoverType, popover?.text),
          popoverType: popoverTypeIndexMap[activePopoverType],
          button: {
            enabled: playButtonStatus,
            color: playerColor
          }
        })
      ),
    [playButtonStatus, activePopoverType, popover?.text]
  );

  useEffect(() => {
    const currentPopoverType = popoverTypeIndexMap[activePopoverType];

    if (
      currentPopoverType === popover?.popoverType &&
      playButtonStatus === popover?.button.enabled
    ) {
      return;
    }

    updatePopover();
  }, [activePopoverType, playButtonStatus]);
};
